var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.tasks.length)?_c('TaskLists'):_c('NoTasks'),(_vm.$store.state.sorting)?_c('ButtonDoneSorting'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }